export default "__VITE_ASSET__B$wMIq6o__"